module.exports = __webpack_public_path__ + "img/iPhone.7c02a5f8.svg";